import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppMenuCheck - a settings-menu checkbox item (`menuitemcheckbox`, state in `aria-checked`) and its one delegated
// document click listener. Shared by `AppMarkRead` and `AppDemo` (review #4240/#4241). Habitat-free: the document is
// reached through `globalThis` (the Bridge typecheck has no DOM lib).

export class AppMenuCheck {
    /** The item's markup. DOCUMENTED EXCEPTION: pure markup from the caller's constants. */
    public static Html = (Attr: string, Value: string, On: boolean, Tip: string, Words: string): string => {
        let Checked: string = "false";
        if (On === true) { Checked = "true"; }
        return "<button type=\"button\" class=\"menuitem\" role=\"menuitemcheckbox\" " + Attr + "=\"" + Value + "\" aria-checked=\""
            + Checked + "\" title=\"" + Tip + "\"><span class=\"mcheck\" aria-hidden=\"true\"></span><span>" + Words + "</span></button>";
    };

    /** One click listener on the document; `Where` names the caller for the handler. */
    public static Listen = (OnClick: (Ev: Event) => void, Where: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            const Doc: { addEventListener?(T: string, F: (Ev: Event) => void): void } | undefined =
                (globalThis as unknown as { document?: { addEventListener?(T: string, F: (Ev: Event) => void): void } }).document;
            if (Doc === undefined || typeof Doc.addEventListener !== "function") { return; }
            Doc.addEventListener("click", OnClick);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Where);
        }
    };
}
